import { Grid } from "@material-ui/core";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { ErrorModal } from "../../../components/modals/error-modal";
import { TableLogs } from "./components/LogsTable/TableLogs";
import { useLogsContext } from "./context/LogsContext";
import { Log } from "./models/Log";
import { getLogs } from "./repositories/LogsRepository";

type Props = {};

export const Logs = (prop: Props) => {
	const [loading, setLoading] = useState<boolean>(true);
	const [error, setError] = useState<string>("");
	const {
		state: { searchData: { Start, End, Search, LogTypeCode } },
		state,
		actions,
	} = useLogsContext();

	const getLogsFromAPI = async () => {
		let canceled = false;
		setLoading(true);
		const res = await getLogs(Start, End, Search, LogTypeCode);
		if (res.ok) {
			const logs: Log[] = get(res, "data.tables[0].rows", []);

			if (canceled) return;

			actions.setLogs(logs);
		} else setError(res.message);

		if (canceled) return;
		setLoading(false);

		return () => {
			canceled = true;
		};
	};

	useEffect(() => {
		getLogsFromAPI();
	}, []);

	return (
		<>
			<Grid container justifyContent="center" alignItems="center">
				<Grid item md={12} xs={12} style={{ margin: 0 }}>
					<div style={{ width: "100%", padding: "10px 0 20px" }}>
						<TableLogs
							isLoading={loading}
							rowData={state.logs}
							refreshData={getLogsFromAPI}
						/>
					</div>
				</Grid>
			</Grid>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
